export default __webpack_public_path__ + "static/media/wireframe2.87d2c499.png";